import { render } from "./SalesSummaryComponent.vue?vue&type=template&id=56cebdcd"
import script from "./SalesSummaryComponent.vue?vue&type=script&lang=js"
export * from "./SalesSummaryComponent.vue?vue&type=script&lang=js"

import "./SalesSummaryComponent.vue?vue&type=style&index=0&id=56cebdcd&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/dashboard/SalesSummaryComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "56cebdcd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('56cebdcd', __exports__)) {
    api.reload('56cebdcd', __exports__)
  }
  
  module.hot.accept("./SalesSummaryComponent.vue?vue&type=template&id=56cebdcd", () => {
    api.rerender('56cebdcd', render)
  })

}


export default __exports__